"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageCard = exports.PageCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_card_1 = require("./entity-card");
var entity_value_1 = require("./entity-value");
var entity_list_1 = require("./entity-list");
var entity_multi_value_list_1 = require("./entity-multi-value-list");
var coalesce_1 = require("../../utils/coalesce");
exports.PageCardDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('text'))
});
var LinkedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n  "])), LinkedStyles, theme_1.theme.UNIT(1))
});
var SitesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "; \n  "], ["\n    ", "; \n  "])), LinkedStyles)
});
var SlicesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0;\n    padding-top: ", ";\n  "], ["\n    padding: 0;\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: -", ";\n    padding-bottom: ", ";\n  "], ["\n    margin-top: -", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3))
});
var TypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n  "])), LinkedStyles, theme_1.theme.UNIT(1))
});
var ParentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n  "])), LinkedStyles, theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_card_1.EntityCard)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Sites: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles),
  Slices: (0, styled_components_1.default)(entity_multi_value_list_1.EntityMultiValueList)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SlicesStyles),
  Siblings: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles),
  Type: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  Parent: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ParentStyles),
  Footer: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
var PageCard = function (props) {
  var className = props.className,
    entity = props.entity;
  var layout = entity.layout,
    parent = entity.parent,
    type = entity.type,
    _a = entity.sites,
    sites = _a === void 0 ? [] : _a,
    _b = entity.siblings,
    siblings = _b === void 0 ? [] : _b,
    _c = entity.slices,
    slices = _c === void 0 ? [] : _c;
  var description = (0, coalesce_1.coalesce)(entity, ['description.text', 'openGraph.description.text']);
  var hasDescription = !!description;
  var hasSites = !!sites.length;
  return react_1.default.createElement(My.Container, {
    entity: entity,
    className: className,
    showFollowControls: false,
    afterDescription: react_1.default.createElement(My.Footer, null, react_1.default.createElement(My.Slices, {
      maxItems: hasDescription ? 3 : 8,
      headerLabel: "Content Slices",
      items: slices
    }), type && react_1.default.createElement(My.Type, {
      variant: 'card',
      entity: type
    }), parent && react_1.default.createElement(My.Parent, {
      label: "Parent Page",
      variant: 'card',
      entity: parent
    }), !!siblings.length && react_1.default.createElement(My.Siblings, {
      label: "Sibling Page",
      variant: 'card',
      items: siblings
    }))
  });
};
exports.PageCard = PageCard;
exports.PageCard.defaultProps = exports.PageCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;